import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * HOF-696 D12/D6 — "Bitte im Büro melden". Shown when the server refuses the
 * worker (`403 labour_access_ended`: the seat no longer matches the employee card)
 * or the farm switched the app off (`403 app_not_active`) — and, from LabourRoute,
 * when the sync already suspended the seat (`/auth/me` → `labour_access_ended`, no
 * active seat left). Nothing the worker can fix on the phone, so the screen says who can.
 */
export type LabourBlockReason = 'access_ended' | 'app_not_active';

const LabourBlocked: React.FC<{ reason: LabourBlockReason }> = ({ reason }) => {
  const { t } = useTranslation();
  return (
    <section className="mgl-card lab-blocked" role="alert" aria-labelledby="lab-blocked-title">
      <h1 id="lab-blocked-title" className="lab-blocked__title">
        {t('labour.blocked.title')}
      </h1>
      <p className="lab-blocked__body">
        {reason === 'app_not_active' ? t('labour.blocked.appOff') : t('labour.blocked.accessEnded')}
      </p>
    </section>
  );
};

export default LabourBlocked;
